import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "../../components/data/DataTable";
import { listMovements } from "../../api/warehouse";

const KIND_COLORS = { receipt: "emerald", issue: "rose", transfer_in: "sky",
                       transfer_out: "amber", adjustment: "violet" };

// تبويب حركات المخزون: سجل زمني بكل الدخول والخروج والمناقلات.
export const WhMovementsTab = ({ branchId }) => {
  const { t, i18n } = useTranslation();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    listMovements({ branch_id: branchId || undefined }).then((d) => setRows(d.items || []))
      .catch(() => setRows([]));
  }, [branchId]);

  const num = (n) => new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(n || 0);
  const columns = [
    { key: "date", label: t("warehouse.mv.date"),
      render: (r) => <span className="num font-mono text-[11px]">{r.date}</span> },
    { key: "number", label: t("warehouse.mv.ref"),
      render: (r) => <span className="num font-mono text-xs font-bold text-primary">{r.ref_doc_number}</span> },
    { key: "kind", label: t("warehouse.mv.kind"),
      render: (r) => (
        <span className={`rounded-full bg-${KIND_COLORS[r.kind] || "slate"}-500/15 px-2 py-0.5 text-[10px] font-bold text-${KIND_COLORS[r.kind] || "slate"}-700`}>
          {t(`warehouse.mv.kinds.${r.kind}`, r.kind)}</span>) },
    { key: "item", label: t("warehouse.bal.item"),
      render: (r) => <span className="text-xs">{r.item_name}</span> },
    { key: "qty", label: t("warehouse.mv.qty"),
      render: (r) => <span className={`num font-mono font-bold ${r.qty > 0 ? "text-emerald-600" : "text-rose-600"}`}>
        {r.qty > 0 ? "+" : ""}{num(r.qty)}</span> },
    { key: "cost", label: t("warehouse.mv.cost"),
      render: (r) => <span className="num font-mono text-[11px]">{num(r.unit_cost)}</span> },
    { key: "value", label: t("warehouse.mv.value"),
      render: (r) => <span className="num font-mono text-[11px] text-muted-foreground">{num(r.total_value)}</span> },
  ];

  return <DataTable testid="mv-table" columns={columns} rows={rows} rowKey={(r) => r.movement_id}
                    empty={t("warehouse.mv.empty")} />;
};
